module.exports = __webpack_public_path__ + "static/media/close.442c6104.svg";